import React from 'react';
import { Popover } from '@sm360/ui-library';
import { LocaleService } from '@sm360/widget-commons-core-services';

import './SharingBar.scss';

const SharingBar = () => (
    <div className="sharing-bar">
        <Popover
            position="bottom"
            trigger={
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 32 32"
                        focusable="false"
                    >
                        <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m0 30.49C7.997 30.49 1.51 24.002 1.51 16S7.998 1.51 16 1.51c8.003 0 14.49 6.488 14.49 14.49-.009 7.999-6.491 14.482-14.49 14.49" />
                        <path d="M21.675 11.523a3.376 3.376 0 1 0-3.233-2.396l-.006-.024-8.027 4.603a3.377 3.377 0 1 0 .015 4.844l-.001.001 7.965 4.517a3.3 3.3 0 0 0-.091.782v.005a3.38 3.38 0 1 0 1.008-2.417l-7.966-4.517a3.4 3.4 0 0 0-.004-1.612l.005.023 8.111-4.648a3.34 3.34 0 0 0 2.222.839h.006z" />
                    </svg>
                    <span>{LocaleService.t('COMMONS_GENERAL.SHARE.SHARE')}</span>
                </div>
            }
        >
            <div className="sharing-bar__wrapper">
                <span className="st_email_large" displayText="Email" />
                <span className="st_twitter_large" displayText="Tweet" />
                <span className="st_facebook_large" displayText="Facebook" />
            </div>
        </Popover>
    </div>
);

SharingBar.displayName = 'SharingBar';

export default SharingBar;
